import {min, sqrt} from "../math.js";

export default {
  draw(context, size) {
    const r = sqrt(size - min(size / 6, 1.7)) * 0.6189;
    context.moveTo(-r, -r);
    context.lineTo(r, r);
    context.moveTo(-r, r);
    context.lineTo(r, -r);
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/symbol/times.js
// module id = 247
// module chunks = 0